/**
 * Quick Add Modal Functionality
 * Opens product details in Fancybox modal for quick add to cart
 */

(function($) {
  'use strict';

  var QuickAdd = {
    
    init: function() {
      this.bindEvents();
    },

    bindEvents: function() {
      var self = this;
      
      // Open quick add modal
      $(document).on('click', '.quick-add-button', function(e) {
        e.preventDefault();
        self.openModal($(this));
      });

      $(document).on('click', '.quick-add-full-details', function() {
        if (window.fwTrack) {
          window.fwTrack('quick_add_details', {
            product_name: $.trim($('#quick-add-modal .quick-add-title').text())
          });
        }
      });

      // Variant price update
      $(document).on('change', '.quick-add-variant-select', function() {
        self.updatePrice($(this));
      });

      $(document).on('click', '.quick-add-size-toggle', function(e) {
        e.preventDefault();
        var $size = $(this).closest('.quick-add-size');
        var open = !$size.hasClass('is-open');
        $('.quick-add-size').removeClass('is-open');
        $('.quick-add-size-toggle').attr('aria-expanded', 'false');
        if (open) {
          $size.addClass('is-open');
          $(this).attr('aria-expanded', 'true');
        }
      });

      $(document).on('click', '.quick-add-size-option', function(e) {
        e.preventDefault();
        var $option = $(this);
        var $size = $option.closest('.quick-add-size');
        var $select = $size.find('.quick-add-variant-select');
        $select.val($option.attr('data-value')).trigger('change');
        $size.find('.quick-add-size-option').removeClass('is-selected');
        $option.addClass('is-selected');
        $size.find('.quick-add-size-toggle').text($option.text());
        $size.removeClass('is-open');
        $size.find('.quick-add-size-toggle').attr('aria-expanded', 'false');
      });

      $(document).on('click', function(e) {
        if (!$(e.target).closest('.quick-add-size').length) {
          $('.quick-add-size').removeClass('is-open');
          $('.quick-add-size-toggle').attr('aria-expanded', 'false');
        }
      });

      // Add to cart form submission
      $(document).on('submit', '.quick-add-form', function(e) {
        e.preventDefault();
        self.addToCart($(this));
      });
    },

    openModal: function($button) {
      var self = this;
      var handle = $button.data('product-handle');
      var $item = $button.closest('.product-list-item');
      var subtitle = $.trim($item.find('.h1-bottom-header').text());
      var badgeHtml = $item.find('.jdgm-preview-badge').html() || '';
      var productName = $.trim($item.find('.h1-top-header').first().text());

      if (window.fwTrack) {
        window.fwTrack('choose_options', {
          product_name: productName,
          product_handle: handle
        });
      }

      if (!handle || !$('#quick-add-modal').length) {
        return;
      }

      $button.prop('disabled', true);
      $.getJSON('/products/' + handle + '.js')
        .done(function(product) {
          self.fillModal(product, subtitle, badgeHtml);
          self.showModal();
        })
        .fail(function() {
          alert('Unable to load this product. Please try again.');
        })
        .always(function() {
          $button.prop('disabled', false);
        });
    },

    money: function(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof Theme !== 'undefined') {
        return Shopify.formatMoney(cents, Theme.moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    },

    sizedImage: function(url, width) {
      if (!url) {
        return '';
      }
      if (url.indexOf('//') === 0) {
        url = 'https:' + url;
      }
      var join = url.indexOf('?') === -1 ? '?' : '&';
      return url + join + 'width=' + width;
    },

    fillModal: function(product, subtitle, badgeHtml) {
      var $modal = $('#quick-add-modal');
      var img = product.featured_image;
      var available = [];
      var i;
      var variant;
      var optionName = 'Size';
      var $select = $modal.find('.quick-add-variant-select');
      var $option;

      if (img && typeof img === 'object') {
        img = img.src || '';
      }

      $modal.find('.quick-add-image img')
        .attr('src', this.sizedImage(img, 600))
        .attr('alt', product.title);
      var $thumb = $modal.find('.quick-add-details-thumb');
      if (img) {
        $thumb.attr('src', this.sizedImage(img, 96)).show();
      } else {
        $thumb.removeAttr('src').hide();
      }
      $modal.find('.quick-add-vendor').text(product.vendor || '');
      $modal.find('.quick-add-title').text(product.title || '');

      if (subtitle) {
        $modal.find('.quick-add-subtitle').text(subtitle).show();
      } else {
        $modal.find('.quick-add-subtitle').text('').hide();
      }

      $modal.find('.quick-add-badge').html(badgeHtml);
      $modal.find('.quick-add-full-details').attr('href', '/products/' + product.handle);
      $modal.find('.quick-add-quantity-input').val('1');
      $select.empty();

      for (i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          available.push(product.variants[i]);
        }
      }

      if (product.options && product.options.length === 1) {
        optionName = product.options[0].name || product.options[0];
      }
      $modal.find('.quick-add-option-label').text(optionName + ':');

      if (!available.length) {
        $modal.find('.quick-add-form').hide();
        $modal.find('.sold-out-message').show();
        $modal.find('.quick-add-price').html('<span class="sold-out">Sold out</span>');
        return;
      }

      $modal.find('.quick-add-form').show();
      $modal.find('.sold-out-message').hide();

      if (available.length === 1 && available[0].title === 'Default Title') {
        $modal.find('.quick-add-variants').hide();
        $modal.find('.quick-add-variant-id').val(available[0].id).prop('disabled', false);
        $select.prop('disabled', true);
      } else {
        $modal.find('.quick-add-variants').show();
        $modal.find('.quick-add-variant-id').prop('disabled', true);
        $select.prop('disabled', false);
        for (i = 0; i < available.length; i++) {
          variant = available[i];
          $option = $('<option></option>');
          $option.val(variant.id).text(variant.title);
          $option.attr('data-price', this.money(variant.price));
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            $option.attr('data-compare-price', this.money(variant.compare_at_price));
          }
          $select.append($option);
        }
        this.renderSizeMenu($select);
      }

      this.updatePrice($select);
      if (!$select.find('option').length) {
        $modal.find('.quick-add-price').html(
          '<span class="price"><span class="money">' + this.money(available[0].price) + '</span></span>'
        );
      }
    },

    renderSizeMenu: function($select) {
      var $size = $select.closest('.quick-add-size');
      var $menu = $size.find('.quick-add-size-menu');
      var $toggle = $size.find('.quick-add-size-toggle');
      $menu.empty();
      $size.removeClass('is-open');
      $toggle.attr('aria-expanded', 'false');
      $select.find('option').each(function() {
        var $item = $('<button type="button" class="quick-add-size-option"></button>');
        $item.attr('data-value', this.value).text($(this).text());
        if (this.selected) {
          $item.addClass('is-selected');
        }
        $menu.append($('<li></li>').append($item));
      });
      $toggle.text($select.find('option:selected').text() || '');
    },

    showModal: function() {
      var self = this;

      if (typeof Fancybox !== 'undefined') {
        if (self.instance) {
          self.instance.close();
        }
        self.instance = new Fancybox([{
          src: '#quick-add-modal',
          type: 'inline'
        }], {
          animated: false,
          mainClass: 'quick-add-fancybox',
          on: {
            done: function() {
              self.convertModalPrices();
            }
          }
        });
      } else if (typeof $.fancybox !== 'undefined') {
        $.fancybox.open({
          src: '#quick-add-modal',
          type: 'inline',
          opts: {
            touch: false,
            buttons: ['close'],
            smallBtn: true,
            afterShow: function() {
              self.convertModalPrices();
            }
          }
        });
      }
    },

    convertModalPrices: function() {
      try {
        if (typeof Currency !== 'undefined' && typeof Currency.convertAll !== 'undefined') {
          var currentCurrency = jQuery('[name=currencies]').val() || shopCurrency;
          jQuery('.fancybox__content .money').each(function() {
            var $money = jQuery(this);
            var attrs = $money[0].attributes;
            var i;
            for (i = attrs.length - 1; i >= 0; i--) {
              if (attrs[i].name.indexOf('data-currency') === 0) {
                $money.removeAttr(attrs[i].name);
              }
            }
          });
          Currency.convertAll(shopCurrency, currentCurrency, '.fancybox__content .money');
        }
      } catch (e) {}
    },

    updatePrice: function($select) {
      var $option = $select.find('option:selected');
      var price = $option.data('price');
      var comparePrice = $option.data('compare-price');
      var $priceContainer = $select.closest('.quick-add-details').find('.quick-add-price');
      
      if (price) {
        var priceHtml = '<span class="price"><span class="money">' + price + '</span>';
        // Only show compare price if it exists, is not $0.00, and is higher than price
        if (comparePrice && comparePrice !== '$0.00' && comparePrice !== '$0.00 AUD' && comparePrice !== price && comparePrice !== '0') {
          priceHtml += ' <span class="original money">' + comparePrice + '</span>';
        }
        priceHtml += '</span>';
        $priceContainer.html(priceHtml);
        
        // Re-trigger Shopify currency converter if present (with error handling)
        try {
          if (typeof Currency !== 'undefined' && typeof Currency.convertAll !== 'undefined') {
            var currentCurrency = jQuery('[name=currencies]').val();
            if (currentCurrency) {
              Currency.convertAll(shopCurrency, currentCurrency);
            }
          }
        } catch(e) {
          // Currency conversion failed, prices still display correctly
          console.log('Currency conversion skipped:', e.message);
        }
      }
    },

    addToCart: function($form) {
      var $button = $form.find('.quick-add-submit');

      if ($button.prop('disabled')) {
        return;
      }

      var originalText = $button.data('original-text');
      if (!originalText) {
        originalText = $.trim($button.text());
        $button.data('original-text', originalText);
      }

      $button.prop('disabled', true).css({ opacity: 0.5 });

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $form.serialize(),
        dataType: 'json',
        success: function() {
          $.getJSON('/cart.js', function(cart) {
            $('.cart-count').text(cart.item_count);
          });

          $button.css({ opacity: 1 }).text('Added!');
          setTimeout(function() {
            $button.prop('disabled', false).text(originalText);
          }, 1500);
        },
        error: function(xhr) {
          var error = 'Unable to add to cart';
          try {
            var response = JSON.parse(xhr.responseText);
            error = response.description || error;
          } catch(e) {}

          alert(error);
          $button.prop('disabled', false).css({ opacity: 1 }).text(originalText);
        }
      });
    }
  };

  // Initialize when document is ready
  $(document).ready(function() {
    QuickAdd.init();
  });

})(jQuery);
